<template>
  <div></div>
</template>

<script>
export default {
  name: 't-default-layout',
  props: {},
  computed: {},
};
</script>
